import type { CustomerAcknowledgmentConfig } from '../types';

export const parseAcknowledgmentConfig = (
  blobText: string | null | undefined
): CustomerAcknowledgmentConfig => {
  const defaultConfig: CustomerAcknowledgmentConfig = {
    statement: null
  };

  if (!blobText) return defaultConfig;

  try {
    const parsed = JSON.parse(blobText);
    return {
      statement:
        typeof parsed?.statement === 'string' ? parsed.statement : null,
      version: parsed?.version
    };
  } catch {
    return defaultConfig;
  }
};

export const stringifyAcknowledgmentConfig = (
  config: CustomerAcknowledgmentConfig
): string => {
  return JSON.stringify(config);
};

export const hasCustomStatement = (
  config: CustomerAcknowledgmentConfig
): boolean => {
  return config.statement !== null && config.statement.trim().length > 0;
};
